import React from 'react'
import {
    Route,
    HashRouter,
    Switch,
} from 'react-router-dom'
import DashboardContainer from '../containers/DashboardContainer'
import LoginContainer from '../containers/DeviseContainer/LoginContainer'
import DeviseDashboardContainer from '../containers/DeviseDashboardContainer'
import HealthQuestionnaireContaioner from '../containers/HealthQuestionnaireContaioner'
import ApplicationForAdmissionContaioner from '../containers/ApplicationForAdmissionContaioner'
import ParentalStatusSurveyContaioner from '../containers/ParentalStatusSurveyContaioner'
import TransferStudentContaioner from '../containers/TransferStudentContaioner'
import ParentPassContaioner from '../containers/ParentPassContaioner'
import {ConnectedRouter} from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

const history = createHistory()

export default class MainRouter extends React.Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={DashboardContainer}/>
                        <Route exact path="/devise_dashboard" component={DeviseDashboardContainer}/>
                        <Route exact path="/login" component={LoginContainer}/>
                        <Route exact path="/application_for_admission" component={ApplicationForAdmissionContaioner}/>
                        <Route exact path="/health_questionnaire" component={HealthQuestionnaireContaioner}/>
                        <Route exact path="/parental_status_survey" component={ParentalStatusSurveyContaioner}/>
                        <Route exact path="/transfer_student" component={TransferStudentContaioner}/>
                        <Route exact path="/parent_pass" component={ParentPassContaioner}/>
                    </Switch>
                </HashRouter>
            </ConnectedRouter>
        )
    }
}




// WEBPACK FOOTER //
// ./src/dashboards_redux/router/MainRouter.jsx